import React, { Suspense } from 'react';
import Landing from './components/Landing';
import { GameStateProvider } from './context/provider.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (  
    <GameStateProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <Landing />
      </Suspense>
    </GameStateProvider>
  ); 
}

export default App;